import React from "react";
import AgTable from "../../components/AgTable";
import { AgColDef } from "../../components/AgTable/types";
import { useStoreState } from "../../hooks/ep";
import { getEnrollmentBuzzUrl } from "../../entities/ecp/ecp-enrollment-entity";
import _ from "lodash";
import {
  getStudentBuzzUrl,
  getStudentGeniusUrl,
} from "../../entities/ecp/ecp-student-entity";
import { useEnsureData } from "../../helpers/use-ensure-data";
import { Spinner } from "@blueprintjs/core";

export function EnrollmentActivitySummaryByDayTable({
  fullScreenEnabled = true,
  customRibbonElements = [],
  ...restProps
}): JSX.Element {
  const loading = _.max([useEnsureData("enrollmentActivitySummaryByDay")]);

  return loading ? (
    <Spinner />
  ) : (
    <EnrollmentActivitySummaryByDayContent
      fullScreenEnabled={fullScreenEnabled}
      customRibbonLeftElements={customRibbonElements}
      {...restProps}
    />
  );
}

function EnrollmentActivitySummaryByDayContent({ ...restProps }): JSX.Element {
  const rowData = useStoreState(
    (s) => s.enrollmentActivitySummaryByDay.initialData
  );

  const colDefs = useEnrollmentActivitySummaryByDayColDefs();

  return (
    <AgTable
      tableName={"enrollment-activity-summary-by-day"}
      rowData={rowData}
      columnDefs={colDefs}
      ribbonTitle={"Enrollment Activity Summary By Day (Last 7 days)"}
      {...restProps}
    />
  );
}

function useEnrollmentActivitySummaryByDayColDefs(): AgColDef[] {
  return [
    {
      headerName: "Student Name",
      field: "customer_name",
      type: "textColumn",
      width: 150,
      pinned: "left",
      suppressSizeToFit: true,
      tooltipField: "customer_name",
    },
    {
      headerName: "Buzz Enr",
      field: "eLMSID",
      type: "linkedTextColumn",
      pinned: "left",
      __linkValueGetter: getEnrollmentBuzzUrl,
      __linkIsNotAnEmail: true,
    },
    {
      headerName: "Activity Start Day (UTC)",
      field: "activity_start_day",
      pinned: "left",
      type: "naiveDateColumn",
    },
    {
      headerName: "Department",
      field: "DepartmentName",
      type: "categoryColumn",
    },
    {
      headerName: "Course",
      field: "CourseName",
      type: "textColumn",
      width: 225,
      suppressSizeToFit: true,
      tooltipField: "CourseName",
    },
    {
      headerName: "Total Activity Duration (s)",
      field: "total_activity_duration_seconds",
      type: "integerColumn",
    },
    {
      headerName: "Total Activity Duration (h)",
      field: "total_activity_duration_hours",
      type: "floatColumn",
      __nDecimals: 3,
    },
    {
      headerName: "SoR",
      field: "sSchoolRecord",
      type: "booleanColumn",
    },
    {
      headerName: "Stu Grade Level",
      field: "sGradeLevel",
      type: "integerColumn",
      filter: "categoryFilterer",
      cellClass: "ag-numeric-cell",
      width: 130,
    },
    {
      headerName: "Country",
      field: "Country",
      type: "textColumn",
    },
    {
      headerName: "State",
      field: "State",
      type: "textColumn",
    },
    {
      headerName: "City",
      field: "City",
      type: "textColumn",
    },
    {
      headerName: "ZIP",
      field: "ZIP",
      type: "textColumn",
    },
    {
      headerName: "Buzz Stu",
      field: "student_lmsid",
      type: "linkedTextColumn",
      __linkValueGetter: getStudentBuzzUrl,
      __linkIsNotAnEmail: true,
    },
    {
      headerName: "Genius Stu",
      field: "StudentIndex",
      type: "linkedTextColumn",
      __linkValueGetter: getStudentGeniusUrl,
      __linkIsNotAnEmail: true,
      width: 97,
    },
    {
      headerName: "Genius Enrollment ID",
      field: "EnrollmentIndex",
      type: "integerIdentifierColumn",
    },
    {
      headerName: "Genius Course ID",
      field: "CourseIndex",
      type: "integerIdentifierColumn",
    },
  ];
}
